<template>
  <div class="auction">
    <Add :info="info" ref="dislog"></Add>
    <div class="htit">
      <div class="h3">拍卖记录</div>
    </div>
    <div class="rbox">
      <a-radio-group button-style="solid" v-model='item_type' @change="init(1)">
        <a-radio-button :value="1">车辆({{ nums.car_count }})</a-radio-button>
        <a-radio-button :value="2">房产({{ nums.house_count }})</a-radio-button>
        <a-radio-button :value="3">其他({{ nums.other_count }})</a-radio-button>
      </a-radio-group>
      <div class="rt">
        <a-button icon="plus" type="primary"  ghost @click="add" v-if="$common.AccAUTH($store.state.cause.accuser.id,'debinfo:auction:add')">添加</a-button>
      </div>
    </div>
    <div class="ntable table" v-if="list.length>0">
      <table cellpadding="0" cellspacing="0">
        <thead>
          <td width="50">序号</td>
          <td width="120">拍卖物名称</td>
          <td width="120">所有人</td>
          <td width="120" v-if="item_type==1">车牌号</td>
          <td width="120">估值（元）</td>
          <td width="120">拍卖阶段</td>
          <td  width="120">拍卖状态</td>
          <td  width="150">拍卖开始时间</td>
          <td  width="150">操作</td>
        </thead>
        <tbody>
          <tr v-for="(i,index) in list" >
            <td>{{ (index+1)+(page-1)*5 }}</td>
            <td>
              <Normap :tit="i.title"></Normap>  
            </td>
            <td>{{ i.belong_debtor.realname }}</td>
            <td  v-if="item_type==1">{{ i.car_license_number }}</td>
            <td>
              <span v-if="i.value">{{ i.value | showYuan }}</span>
              <span v-else>/</span>
            </td>
            <td>{{ stageKey(i.auction_step)  }}</td>
            <td>{{ statusKey(i.auction_status) }}</td>
            <td>{{ i.auction_start_time }}</td>
            <td>
              <a href='javascript:void(0);' @click='see(i,0)'>查看</a>
              <a href='javascript:void(0);' @click="see(i,2)" v-if="$common.AccAUTH($store.state.cause.accuser.id,'debinfo:auction:edit')"><span class="line"></span>修改</a>
              <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='del(i.id)' v-if="$common.AccAUTH($store.state.cause.accuser.id,'debinfo:auction:del')"> 
                <a href="javascript:void(0);" style="color:#f00;"> <span class="line"></span>删除</a>
              </a-popconfirm>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pages" v-if='total>5'>
      <a-pagination v-model="page" show-quick-jumper :total="total" show-less-items :pageSize='5' @change='(e)=>{init(e)}' />
    </div>
  </div>
</template>
<script>
  import Add from './add'
  import { auction ,AgetCounts} from '@/server/debtor'
  import {stageKey,statusKey,typeKey} from './keys'
  export default {
    // props:{
    //   causeId:Number,
    // },
    components:{ Add },
    data(){
      return {
        info:{},
        list:[],
        total:5,
        page:1,
        item_type:1,
        nums:{}
      }
    },
    created(){
      this.init(1)
    },
    name:'Auction',
    methods:{
      stageKey,statusKey,typeKey,
      init(page){
        const id=this.$store.state.cause.id
        this.getNums(id)
        this.page=page
        auction({cause_id:id,item_type:this.item_type,page:page,limit:5},'index').then(e=>{
          this.total=e.count
          this.list=e.list
        })  
      },
      getNums(id){
        AgetCounts({cause_id:id}).then(e=>{
          this.nums=e
        })
      },
      see(info,edit){
        this.info=info
        this.$refs.dislog.edit=edit
        this.$refs.dislog.visible=true
      },
      del(id){
        auction({id:id},'del').then(e=>{
          this.$message.success('删除成功')
          this.init(1)
        })  
      },
      add(){
        this.info={
          item_type:null,
          auction_status:1,
          files:[]
        }
        this.$refs.dislog.edit=1
        this.$refs.dislog.visible=true
      }
    }
  }
</script>
<style lang="less" scoped>
  .auction {
    .rbox{
      padding:0 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }
    .htit{
      border:0 none;
    }
    
  }
</style>